import { Link } from "react-router-dom"
import BestSellers from "../cards/bestsellerscard"
import BestSellersCarousel from "../components/home/bestsellerscarousel"
import SwiperCarousel from "../components/home/swipercarousel"
import SwiperNav from "../features/swipernav"
import ProductsCard from "../cards/productscard"
import ModalAgeAuthentication from "./modalageauthentication"

const Home = ({fanFavs, fanFavsMock, setVerified, mocktails, verified, setMocktails}) => {

    return (
        <div >
            <section id="hero" >
                <div className="container">
                    <div className="row">
                        <div className="tt-header-content col-md-6 p-4">
                            <div className="">
                                { mocktails ? 
                                    <h1 className="fw-bold tt-header-hero-fs" >PURE THIRST.<br/><span className="text-primary">ZERO PROOF.</span>
                                        <br />
                                        BOLD. 
                                        <br />
                                        <span className="text-primary">NATURAL.</span >
                                        {/* <span className="text-primary">BOLD. NATURAL.</span > */}
                                    </h1> :
                                    <h1 className="fw-bold tt-header-hero-fs" >10% ABV<br/><span className="text-primary">100% FIRE</span>
                                        <br />
                                        NATURAL 
                                        <br />
                                        <span className="text-primary">REFRESHING</span >
                                    </h1>                                                                    
                                }


                                <p className="tt-header-info text-dark">At Thirst Trap we don't take ourselves seriously, but we definitely take our {mocktails ? "beverages" : "cocktails"} seriously.</p>
                                <Link to="/storelocator" ><button className="tt-button btn">Find Near You</button></Link>
                                <h5 className=" fw-bold pt-3"  >
                                    View our {mocktails ? "cocktails" : "mocktails"} here  
                                    { verified ? 
                                        <Link to="/products" >
                                            <button className="ms-3 tt-button btn bi bi-arrow-right"
                                                onClick={() => {
                                                    setMocktails(!mocktails)
                                                }}
                                            >
                                            </button>
                                        </Link> 
                                        :
                                        <button className="ms-3 tt-button btn bi bi-arrow-right"
                                                data-bs-toggle="modal" 
                                                data-bs-target="#ageAuthentication"
                                                onClick={() => {
                                                    setMocktails(true)
                                                }}
                                        >
                                        </button>
                                    }

                                </h5>

                            </div>
                        </div>
                        <div className="col-md-6 d-flex justify-content-center">
                            { mocktails ?
                                <img src={"https://i.imgur.com/vy59IqV.png"}  className="tt-hero-img img-fluid border border-2 border-dark" alt="" /> :
                                <img src={require("../assets/imgs/home/header4.jpg")}  className="tt-hero-img img-fluid border border-2 border-dark" alt="" />
                        }

                            
                        </div>
                    </div>
                </div>
            </section>

            <main id="id" className="">
                <section id="bestsellers" className="d-none d-md-block">
                    <div className="container">
                        <div className="d-flex flex-column justify-content-center align-items-center mb-5">
                            <h1 className="tt-header-fs fw-bold">WHAT'S <span>HOT</span></h1>
                        </div>{
                            mocktails ? 
                        <div className="row">
                            {fanFavsMock && fanFavsMock.map(product => (
                                <BestSellers key={product.id} product={product} mocktails={mocktails}/>
                                // <ProductsCard  key={product.id} product={product} />
                            ))}
                        </div>    :
                        <div className="row">
                            {fanFavs && fanFavs.map(product => (
                                <BestSellers key={product.id} product={product} mocktails={mocktails}/>
                                // <ProductsCard  key={product.id} product={product} />
                            ))}
                        </div>                                                
                        }

                        <div className="d-flex flex-column justify-content-center align-items-center py-5">
                            <Link to="/products"><button className="tt-button btn">View All {mocktails? 'Mocktails' : 'Cocktails'}</button></Link>
                        </div>
                    </div>
                </section>
                {
                    mocktails ?
                <div className="d-md-none d-block">
                    {fanFavsMock && 
                    <BestSellersCarousel products={fanFavsMock} mocktails={mocktails} >
                        <SwiperNav/>
                    </BestSellersCarousel>}
                </div>  :
                <div className="d-md-none d-block">
                    {fanFavs && 
                    <BestSellersCarousel products={fanFavs} mocktails={mocktails} >
                        <SwiperNav/>
                    </BestSellersCarousel>}
                </div>                                  
                }
                <div className="d-md-none d-block">
                    {fanFavs && 
                    <BestSellersCarousel product={fanFavs} mocktails={mocktails} >
                        <SwiperNav/>
                    </BestSellersCarousel>}
                </div> 

                <section id="ourproduct">
                    <div className="container">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <div className="tt-ourproducts-description d-flex flex-column justify-content-center align-items-center bg bg-success p-3 p-md-5 mb-5">
                                <h1 className="fw-bold tt-header-fs">OUR <span>PRODUCT</span></h1>{
                                    !mocktails ?
                                <p className=" my-3" >Delivering the luxury of handmade in the convenience of a can, we have a fantastic lineup of which are portable and shelf stable. Whether on the sand at the beach, on the mountain, at a festival, or casually with a meal at home, you can Thirst Trap your way.</p> :                                   
                                <p className="my-3 ">Delivering the luxury of handmade craft beverages in ready-to-drink formats, we have a fantastic lineup of beverages which are portable and shelf stable. Whether on the sand at the beach, at a restaurant, on the mountain, at a festival, or casually with a meal at home, you can Thirst Trap your way.</p>                                
                                }


                            </div>
                            <div className="row ">
                                <div className="col-md-4 d-flex flex-column justify-content-center align-items-center ">
                                    <div className="tt-ourproducts-icon d-flex justify-content-center align-items-center bg bg-success p-3"><img src={require("../assets/imgs/home/icon3.png")}  className="img-fluid" alt="" /></div>
                                    <p className="text-dark mt-4 fw-bold">Premium</p>
                                    <p className="text-center text-white px-5" >className aptent taciti sociosqu ad litora torquent</p>
                                </div>
                                <div className="col-md-4 d-flex flex-column justify-content-center align-items-center">
                                    <div className="tt-ourproducts-icon d-flex justify-content-center align-items-center bg bg-success p-4"><img src={require("../assets/imgs/home/icon1.png")}  className="tt-icon-img  img-fluid" alt="" /></div>
                                    <p className="text-center text-dark mt-4 fw-bold">Made with Natural Flavors</p>
                                    <p className="text-centert text-white px-5" >className aptent taciti sociosqu ad litora torquent</p>
                                </div>
                                <div className="col-md-4 d-flex flex-column justify-content-center align-items-center">
                                    <div className="tt-ourproducts-icon d-flex justify-content-center align-items-center bg bg-success p-3"><img src={require("../assets/imgs/home/icon2.png")} className="img-fluid"  alt="" /></div>
                                    <p className="text-dark mt-4 fw-bold">Refreshing</p>
                                    <p className="text-center text-white px-5" >className aptent taciti sociosqu ad litora torquent</p>
                                </div>
                            </div>
                        </div>
                    </div>``
                </section>
            
                <section id="slogan">
                    <div className="container">
                        <div className="row">
                            <h1 className="text-center fw-bold my-lg-5 mx-0 mx-lg-5 d-block d-lg-none">THIRST TRAP <span className="">YOUR WAY</span></h1>
                            <div className=" tt-slogan-card-container order-2 col-4 d-flex flex-column justify-content-end align-items-center mt-5 mt-lg-5">
                                <h1 className="text-center fw-bold my-lg-5 d-none d-lg-block tt-header-fs-slogan">THIRST TRAP <span className="">YOUR WAY</span></h1>
                                { mocktails ? 
                                <img src={"https://i.imgur.com/o0cOrxY.png"} className="tt-slogan-img img-fluid border border-dark border-2" alt="" /> :
                                <img src={require("../assets/imgs/home/slogan_one.png")} className="tt-slogan-img img-fluid border border-dark border-2" alt="" />                                
                                }
                                <p className="fw-bold text-center text-dark mt-4">For <span>Anywhere</span></p>
                            </div>
                            <div className="tt-slogan-card-container order-1 col-4 d-flex flex-column justify-content-center justify-content-lg-start align-items-center mb-5 mb-lg-0">
                                { mocktails ? 
                                    <img src={"https://i.imgur.com/ivGrTIo.jpeg"} className="tt-slogan-img img-fluid border border-dark border-2"  alt="" />   :
                                    <img src={require("../assets/imgs/home/slogan_three.png")} className="tt-slogan-img img-fluid border border-dark border-2"  alt="" />                                
                                }
                                <p className="fw-bold text-center text-dark mt-4">For <span>Anyone</span></p>
                            </div>
                            <div className="tt-slogan-card-container order-3 col-4 d-flex flex-column  justify-content-center justify-content-lg-start align-items-center mb-5 mb-lg-0">
                                { mocktails ? 
                                    <img src={"https://i.imgur.com/6emy3cI.png"} className="tt-slogan-img img-fluid border border-dark border-2"  alt="" />   :
                                    <img src={require("../assets/imgs/home/slogan_two.png")} className="tt-slogan-img img-fluid border border-dark border-2"  alt="" />                                
                                }
                                <p className="fw-bold text-center text-dark mt-4">For <span>Anytime</span></p>
                            </div> 
                        </div> 
                        <div className="d-flex flex-column justify-content-start align-items-center">
                            <Link to="/about"><button className="tt-button btn" >Learn More</button></Link>
                        </div>
                    </div>
                </section>

                <section id="partners">
                    <div className="tt-partners-container bg-success container py-5 d-flex flex-column justify-content-center align-items-center border border-dark border-2 rounded-2">
                        <h1 className="text-center fw-bold mb-5 tt-header-fs">OUR <span>PARTNERS</span></h1>
                        <div className=" p-4 row row-cols-7 row-cols-xlg-3 gy-3">
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/626_night_market_logo.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/cult_logo.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/duffl_logo-transformed.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/jaja_logo.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/lanea_logo-transformed.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/liquidIV_logo-transformed.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/rosewood_miramar_beach_logo-transformed.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/tequila_patron_logo-transformed.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/tinder_logo-transformed.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/waldorf_astoria_logo.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/818_Tequila_Logo.jpg")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/amex_logo.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/bww_logo.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center ">
                                    <img src={require("../assets/imgs/partners/formula1.png")} className="tt-partners-img img-fluid " alt=""/>
                                    {/*  */}
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    
                                    <img src={require("../assets/imgs/partners/greek_theatre_logo.png")} className="tt-partners-img img-fluid" alt=""/> 
                                    {/*  */}
                                </div> 
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/loqui.jpg")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/Nosotros_Tequila___Mezcal_Logo.jpg")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/rosebowl_logo.png")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/sweetfin_logo.jpeg")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/totalwine_logo.gif")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                                <div className="col d-flex justify-content-center align-items-center">
                                    <img src={require("../assets/imgs/partners/usopen_logo.jpeg")} className="tt-partners-img img-fluid" alt=""/>
                                </div>
                        </div>
                    </div>
                </section>

                { !mocktails &&
                    <SwiperCarousel>
                    <SwiperNav />
                    </SwiperCarousel>
                                        
                }

                <ModalAgeAuthentication setVerified={setVerified} />
            </main>

        </div>

    )
}

export default Home
